<template>
    <header
        class="w-full z-20 bg-black drop-shadow-lg border-b border-jackpot-bg bg-[url('/images/circuit.jpg')] bg-cover bg-no-repeat bg-center bg-opacity-25">

        <div class="container mx-auto flex items-center relative">

            <ul class="mx-2 h-12 w-full flex items-center justify-between relative pt-1">

                <li class="flex items-center max-[320px]:gap-0 gap-1 ">
                    <notification-button :authenticated="authenticated"
                        :newMessages="notifications.new"></notification-button>
                    <!-- <div @click="toggleDarkMode" class="flex items-center cursor-pointer">
                        <div class="h-8 w-8 flex items-center justify-center text-inner-border">
                            <i v-if="!isDark" class="fa-solid fa-moon fa-fw text-xl"></i>
                            <i v-else class="fa-solid fa-sun-bright fa-fw text-xl"></i>
                        </div>
                    </div> -->
                    <div @click="toggleSound" class="flex items-center cursor-pointer">
                        <div class="h-8 w-8 flex items-center justify-center text-inner-border">
                            <i v-if="sound" class="fa-solid fa-volume fa-fw text-xl"></i>
                            <i v-else class="fa-solid fa-volume-slash fa-fw text-xl"></i>
                        </div>
                    </div>

                    <div v-if="isTeamWallet" @click="adminShow" class="flex items-center cursor-pointer">
                        <div class="h-8 w-8 flex items-center justify-center text-inner-border">
                            <i class="fa-solid fa-cog fa-fw text-xl"></i>
                        </div>
                    </div>
                </li>

                <li class="flex items-center max-[320px]:gap-1 gap-2">
                    <div v-if="connected && authenticated" @click="toggleBalances"
                        class="max-[320px]:text-xs text-xs text-gray-50 dark:text-gray-200 flex items-center gap-2 rounded bg-gray-400 dark:bg-lobby-bg p-1 cursor-pointer relative">
                        <span class="pl-1 text-xs font-semibold">{{ balance }}</span>
                        <img src="/images/sol.png" class="block h-4 w-4 rounded-full" />
                        <div v-if="showBalances" v-click-outside="vcoConfig"
                            class="absolute top-0 right-0 bg-gray-400 dark:bg-lobby-bg text-xs text-gray-50 dark:text-gray-200 gap-1 rounded cursor-pointer flex flex-col items-end justify-center p-1">
                            <div class="flex items-center justify-end w-full gap-2">
                                <span class="text-xs font-semibold">{{ balance }}</span>
                                <img src="/images/sol.png" class="block h-4 w-4 rounded-full" />
                            </div>
                            <div class="flex w-24 p-1">
                                <div class="flex flex-col flex-1 items-start gap-1">
                                    <div v-for="(value, index) in ticketsBalance" :key="'tickets-header-' + index"
                                        class="flex items-center justify-between gap-1">
                                        <img :src="'/images/prize-' + index + '.png'" class="block h-4 w-4 rounded-full" />
                                        <span class="text-xs font-semibold">{{ value }}</span>
                                    </div>
                                </div>
                                <div class="flex flex-col items-end gap-1 w-12">
                                    <div v-for="(value, slug) in tokensBalance" :key="'tokens-header-' + slug"
                                        class="flex items-center justify-between gap-1">
                                        <span class="flex-1 text-xs font-semibold text-right">{{ value }}</span>
                                        <img :src="rrToken(slug).image" class="block h-4 w-4 rounded-full" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="h-8 w-8 flex items-center gap-2">
                        <div class="text-gray-800 dark:text-gray-400 cursor-pointer" v-if="connected && authenticated"
                            @click="toggleAccountMenu" v-cloak>
                            <div v-if="!account.pfp">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"
                                    class="w-6 h-6">
                                    <path fill-rule="evenodd"
                                        d="M18.685 19.097A9.723 9.723 0 0021.75 12c0-5.385-4.365-9.75-9.75-9.75S2.25 6.615 2.25 12a9.723 9.723 0 003.065 7.097A9.716 9.716 0 0012 21.75a9.716 9.716 0 006.685-2.653zm-12.54-1.285A7.486 7.486 0 0112 15a7.486 7.486 0 015.855 2.812A8.224 8.224 0 0112 20.25a8.224 8.224 0 01-5.855-2.438zM15.75 9a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0z"
                                        clip-rule="evenodd" />
                                </svg>
                            </div>
                            <div v-else>
                                <img :src="account.pfp"
                                    class="block rounded-full object-cover h-8 w-8 border-2 border-gray-400 dark:border-white" />
                            </div>
                        </div>
                        <div class="text-gray-400 dark:text-gray-400" v-else @click="toggleAccountMenu" v-cloak>
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                                stroke="currentColor" class="w-6 h-6">
                                <path stroke-linecap="round" stroke-linejoin="round"
                                    d="M17.982 18.725A7.488 7.488 0 0012 15.75a7.488 7.488 0 00-5.982 2.975m11.963 0a9 9 0 10-11.963 0m11.963 0A8.966 8.966 0 0112 21a8.966 8.966 0 01-5.982-2.275M15 9.75a3 3 0 11-6 0 3 3 0 016 0z" />
                            </svg>
                        </div>
                    </div>
                </li>

                <h1 class="absolute left-1/2 -translate-x-1/2">
                    <span class="hidden">Rumble Racers</span>
                    <wallet-multi-button :dark="isDark"></wallet-multi-button>
                </h1>

            </ul>

        </div>

    </header>
</template>

<script>
import solana from '../mixins/solana'
import NotificationButton from './NotificationButton.vue'
import vClickOutside from 'click-outside-vue3'
import { WalletMultiButton } from 'solana-wallets-vue'

export default {
    name: 'HeaderMenu',
    props: ['connected', 'authenticated', 'isDark', 'notifications', 'account', 'sound', 'isTeamWallet', 'tokens', 'tokensBalance', 'ticketsBalance'],
    components: { NotificationButton, WalletMultiButton },
    directives: { clickOutside: vClickOutside.directive },
    mixins: [solana],
    data() {
        return {
            showBalances: false,
            vcoConfig: {
                handler: this.onClickOutside,
                events: ["dblclick", "click"],
                capture: true
            }
        }
    },
    computed: {
        balance() {
            return this.account ? this.lamportsToSol(this.account.balance, 3) : 0
        }
    },
    methods: {
        onClickOutside(e) {
            this.showBalances = false
        },
        toUpperCase(str) {
            return str.charAt(0).toUpperCase() + str.slice(1)
        },
        toggleAccountMenu() {
            this.emitter.emit('account-menu-toggle')
        },
        toggleDarkMode() {
            this.emitter.emit('toggle-dark-mode')
        },
        toggleSound() {
            this.emitter.emit('toggle-sound', this.sound)
        },
        adminShow() {
            this.emitter.emit('admin-show-clicked')
        },
        toggleBalances() {
            this.showBalances = !this.showBalances
        },
        showDeposit() {
            if (this.authenticated) {
                this.emitter.emit('open-modal', 'deposit_modal')
            }
        },
        rrToken(slug) {
            return this.tokens.find(item => item.slug === slug)
        }
    }
}
</script>
